<template>
  <div class="grouped-product-athena" :class="{'layout-6':show_outer && pc_style}">
    <div class="grouped-product-athena-header" :class="{'group-full':groupProduct.position === 'right' || groupProduct.position === 'below' || groupProduct.position === 'foot'}" v-if="group_products_title">
      <h3 class="title_font">{{ group_products_title }}</h3>
      <p v-if="discounts_tips">{{ discounts_tips.onOff ? discounts_tips.tips_success : discounts_tips.tips_fail }}</p>
    </div>
    <div class="grouped-product-athena-main">
      <!-- 默认样式 -->
      <el-checkbox-group v-model="checked_product_id" class="gpam-form" v-if="groupProduct.style === 'default' && (groupProduct.position === 'button_above' || groupProduct.position === 'button below')">
        <el-checkbox v-for="item in new_group_product" :label="item.ID" :key="item.ID">
          <v-athenaItem :product="item" @add_cart_payload="add_cart_payload"></v-athenaItem>
        </el-checkbox>
      </el-checkbox-group>
      <!-- 卡片样式 -->
      <el-checkbox-group v-model="checked_product_id" class="gpam-form-card" :class="{'default-style':groupProduct.style === 'default','layout-3':galleryShowConfig === 'default' && (groupProduct.position === 'button_above' || groupProduct.position === 'button below')}" v-else>
        <el-checkbox v-for="item in new_group_product" :label="item.ID" :key="item.ID">
          <v-athenaItem :product="item" @add_cart_payload="add_cart_payload"></v-athenaItem>
        </el-checkbox>
      </el-checkbox-group>
    </div>
    <!-- 主商品与组合商品捆绑总价 -->
    <div class="grouped-product-athena-bottom" v-if="groupProduct.position === 'button_above'">
      <div class="gpab-price">
        <div class="gpab-price-icon">
          {{ $t('combined.total_price') }}：
          <span class="iconfont icon-cm-2" style="font-size: 20px; color: #979cac; font-weight: 600"> </span>
        </div>
        <div class="gpab-price-num">
          <v-simplePrice
            mode="regular_price"
            v-if="
              (total_price + main_product_price.price || 0) <
              (total_regular_price + main_product_price.regular_price || 0)
            "
            :price="total_regular_price + main_product_price.regular_price || 0"
          ></v-simplePrice>
          <v-simplePrice
            :price="total_price + main_product_price.price || 0"
            :style="{ marginLeft: '10px' }"
          ></v-simplePrice>
        </div>
      </div>
      <div class="gpab-group-tips" v-if="discounts_tips && discounts_tips.onOff">
        {{ discounts_tips.price_tips_success }}
      </div>
    </div>
    <!-- 加购按钮(组合商品不捆绑销售) -->
    <button
      class="grouped-product-athena-btn secondary_title"
      :class="{
        soldout: add_cart_list.length === 0,
        product_single_add_button_disabled: add_cart_list.length === 0,
      }"
      :style="{
        'background-color':groupProduct.background_color,
        'color':groupProduct.text_color
      }"
      @click="add_cart_list.length && add_cart()"
      v-if="groupProduct.position !== 'button_above'"
    >
      {{ groupProduct.button_text }}
    </button>
  </div>
</template>
<script>
import vAthenaItem from './athenaProcutItem.vue';
import mixAdd from "@/js/mixins/mixAdd";
import { mapState } from 'vuex';
export default {
  //数据流向为v-athenaItem 组件在数据变动时商品会将加购信息传递上来触发add_cart_payload事件,将所有商品的各种信息存入new_group_variants
  props: {
    group_product: {},
    group_products_title: {},
    now_variant_computed_price: {
      //athena主题将详情页选中的商品价格传下
      // default: {},
    },
    group_product_price_rules: {}, //组合商品优惠规则
    now_variant_add_cart_data: {}, //主商品的加购信息
    show_outer: false, //  六等分布局
    pc_style: true, // 判断是否是pc端
    cart_type: {}, // 购物车类型
    theme: {}
  },
  mixins: [mixAdd],
  data() {
    return {
      new_group_product: [], //copy group_product,用于组件内循环变种商品
      new_group_variants: {}, //所有商品的各种信息{ 192033:{id:192033,add_card_payload:[],computed_price:{},stock:true}}
      checked_product_id: [], //当选择框发生变化时会根据选中的id去new_group_variants取加购信息存入checked_product_id
      total_price: 0, //所有选中商品的总价
      total_regular_price: 0, //所有选中商品的原总价
      add_cart_list: [], //存放被选中的组合商品
      addType:'groupProduct',
    }
  },
  computed: {
    main_product_price() {
      let { quantity } = this.now_variant_add_cart_data
      let { price, regular_price } = this.now_variant_computed_price
      return {
        price: quantity * price,
        regular_price: quantity * regular_price,
      }
    },
    discounts_tips() {
      let tips = {
        onOff: false,
        tips_success: '',
        tips_fail: '',
        value: 0,
        discount_type: null,
        price_tips_success: '',
      }
      let checkedProductNum = this.checked_product_id.length
      let groupNum = this.group_product.length
      if (!this.group_product_price_rules || !this.group_product_price_rules.length) return false
      if (checkedProductNum == groupNum) tips.onOff = true
      tips.price_tips_success = 'Add to cart, discount will be displayed in cart.'
      let { discount_type, value } = this.group_product_price_rules[0]
      let groupGap = groupNum - checkedProductNum
      switch (discount_type) {
        case 'percentage':
          tips.tips_fail = this.$t('group.percentage_fail', { groupNum: groupGap, value })
          tips.tips_success = this.$t('group.percentage_success', { value })
          break
        case 'flat':
          tips.tips_fail = this.$t('group.flat_fail', { groupNum: groupGap, value, currency:this.$store.state.options?.base?.currency_symbol })
          tips.tips_success = this.$t('group.flat_success', { value, currency:this.$store.state.options?.base?.currency_symbol })
          break
        case 'fixed_set_price':
          tips.tips_fail = this.$t('group.fixed_set_price_fail', { groupNum: groupGap })
          tips.tips_success = this.$t('group.fixed_set_price_success')
          break

        default:
          break
      }
      return tips
    },
    checked_variants_info() {
      // 被选中的商品的加购参数,同时受到new_group_variants和checked_product_id影响
      let payload = []
      this.total_price = 0
      this.total_regular_price = 0
      if (this.checked_product_id && this.checked_product_id.length) {
        this.checked_product_id = this.checked_product_id.map((item) => {
          let data = this.new_group_variants[item]
          if (!data || !data.computed_price.buy_able) return null
          let { add_card_payload = [], computed_price = {} } = data
          let quantity = add_card_payload[0].quantity
          this.total_price += computed_price.price * quantity
          this.total_regular_price += computed_price.regular_price * quantity
          payload = payload.concat(add_card_payload)
          return item
        })
      }
      return payload
    },
    ...mapState({
      // 组合商品配置
      groupProduct: ({ plugConfig }) => plugConfig.groupProduct || {},
      // 商品详情页商品图显示配置
      galleryShowConfig: ({ options }) => options?.theme?.pages?.product?.config?.gallery_show_config,
    }),
  },
  mounted(){
    this.group_product.forEach(el => {
      this.checked_product_id.push(el.ID);
    });
    this.$el.style.setProperty("--group-background", this.groupProduct.background_color);
    this.$el.style.setProperty("--group-color", this.groupProduct.text_color);
  },
  methods: {
    //数据由v-athenaItem流入并将其new_group_variants
    add_cart_payload(payload) {
      this.$set(this.new_group_variants, payload.id, payload)
    },
  },
  watch: {
    checked_variants_info: {
      handler(newV) {
        if(this.groupProduct.position === 'button_above') {
          this.$emit('checked_variants_info', newV);
        }
        this.add_cart_list = JSON.parse(JSON.stringify(newV));
      },
      immediate: true,
    },
    group_product: {
      handler(newV) {
        this.checked_product = []
        // this.new_group_variants = {}
        if (!newV || !newV.length) {
          this.new_group_product = []
          return
        }
        this.new_group_product = JSON.parse(JSON.stringify(newV))
      },
      immediate: true,
    },
  },
  components: {
    vAthenaItem,
  },
}
</script>
<style scoped lang='scss'>
.grouped-product-athena {
  &-header {
    margin-top: 40px;
    background: #e8edf4;
    padding: 12px;
    text-align: center;
    h3 {
      font-size: 20px;
      font-weight: 600;
      color: #222a40;
    }
    p {
      margin-top: 10px;
      font-size: 13px;
    }
    @media screen and(max-width: 768px) {
      h3 {
        font-size: 15px;
      }
    }
    &.group-full {
      background: unset;
      padding: 0;
      text-align: left;
    }
  }
  &-main {
    ::v-deep.gpam-form {
      display: block;
      & > label {
        display: flex;
        align-items: flex-start;
        margin: 30px 0 0;
        width: 100%;
        .el-checkbox__input > .el-checkbox__inner {
          margin-top: 24px;
          width: 20px;
          height: 20px;
          border: 1px solid #000000;
          border-radius: 2px;
          &::after {
            height: 8px;
            left: 6px;
            top: 3px;
            width: 4px;
            border-color: var(--main-btn-tx);
          }
        }
        .el-checkbox__input.is-checked > .el-checkbox__inner {
          background-color: var(--group-background);
        }
        .el-checkbox__label {
          flex: 1;
        }
      }
    }
    ::v-deep {
      .gpam-form-card {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        margin: 0 -10px;
        & > label { 
          display: flex;
          align-items: flex-start;
          margin: 30px 0 0;
          width: 50%;
          white-space: unset;
          padding: 0 10px;
          .el-checkbox__input {
            position: absolute;
            bottom: 18px;
            left: 20px;
          }
          .el-checkbox__input > .el-checkbox__inner {
            margin-top: 24px;
            width: 20px;
            height: 20px;
            border: 1px solid #000000;
            border-radius: 2px;
            &::after {
              height: 8px;
              left: 6px;
              top: 3px;
              width: 4px;
              border-color: var(--main-btn-tx);
            }
          }
          .el-checkbox__input.is-checked > .el-checkbox__inner {
            background-color: var(--group-background);
          }
          .el-checkbox__label {
            flex: 1;
            padding: 0;
          }
        }
        &.default-style {
          .athena-product-item-card {
            box-shadow: unset;
            &__footer {
              padding-left: 0;
              padding-right: 0;
            }
          }
          & > label {
            .el-checkbox__input {
              left: 10px;
            }
          }
        }
        &.layout-3 {
          & > label {
            width: 33.33%;
          }
          .add-btn-box {
            .add-card-div {
              .add-card-btn {
                .add {
                  font-size: 12px;
                }
                .select {
                  font-size: 12px;
                }
              }
            }
          }
          .athena-product-item-card {
            &__price {
              .regular_price {
                display: none;
              }
            }
          }
        }
      }
      .layout-6 {
        & > label {
          width: 16.66%;
        }
      }
    }
  }
  &-bottom {
    margin-top: 40px;
    .gpab-price {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 20px;
      font-family: Roboto;
      font-weight: 500;
      color: #262626;
      &-icon {
        white-space: nowrap;
      }
      &-num {
        text-align: right;
        & > span {
          white-space: nowrap;
        }
      }
    }
    .gpab-group-tips{
      margin-top: 10px;
      font-size: 13px;
    }
  }
  &-btn {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
    cursor: pointer;
  }
}
.layout-6 {
  .grouped-product-athena-main {
    ::v-deep {
      .gpam-form-card {
        & > label {
          width: 16.66%;
        }
      }
    }
  }
  .grouped-product-athena-btn {
    max-width: 388px;
  }
}
@media screen and(max-width: 768px) {
  .grouped-product-athena {
    &-main {
      ::v-deep.gpam-form {
        & > label {
          margin: 17px 0 0;
          .el-checkbox__input > .el-checkbox__inner {
            margin-top: 21px;
            width: 18px;
            height: 18px;
          }
        }
      }
      ::v-deep {
        .gpam-form-card {
          margin: 0 -7.5px;
          & > label {
            padding: 0 7.5px;
          }
          &.layout-3 {
            margin: 0 -5px;
            & > label {
              padding: 0 5px;
              margin: 20px 0 0;
              .el-checkbox__input {
                bottom: 11px;
                left: 12px;
                .el-checkbox__inner {
                  width: 15px;
                  height: 15px;
                  &::after {
                    left: 4px;
                    top: 1px;
                  }
                }
              }
            }
            .add-btn-box {
              .add-card-div {
                margin-bottom: 5px;
                .add-card-btn {
                  line-height: 24px;
                  padding: 0 6px;
                  .add {
                    font-size: 12px;
                  }
                  .select {
                    .plus {
                      top: 1px;
                      right: -6px;
                    }
                  }
                }
              }
              .add-select-div {
                margin-top: 0;
                .select-div-box {
                  .select-style-box {
                    select {
                      height: 26px;
                      padding: 4px;
                      margin-bottom: 5px;  
                    }
                    .default-select-dropdown::after {
                      right: 8px;
                      font-size: 12px;
                    }
                  }
                }
              }
            }
            .athena-product-item-card {
              &__footer {
                padding: 5px 7px 12px;
              }
              &__title {
                font-size: 12px;
                height: 36px;
              }
              &__qtm {
                .product_qty {
                  height: 26px;
                  margin-bottom: 5px;
                  .subtract {
                    width: 25%;
                  }
                }
              }
              &__price {
                font-size: 12px;
                padding-left: 15px;
              }
              &__var {
                &.varHeight {
                  height: 31px;
                }
              }
            }
          }
        }
      }
    }
    &-btn {
      margin-top: 20px;
      height: 40px;
    }
  }
}
</style>